module.exports = __webpack_public_path__ + "media/assets/images/blog/solar_panels-small-17e9159f98eb77ed69ca23e57e73d6e3.jpeg";